export default "__VITE_ASSET__3bskUt48__"